import React, {useEffect, Fragment} from 'react';
import {CircularProgress, Stack} from '@mui/material';
import {CONNECTION_STATE, PROD_UPDATE_SERVER_URL, EC9600_PARAMS} from './StateConstants.jsx';
import PropTypes from 'prop-types';


import {checkScannerUpdates} from '../../imports/ec9xns/ec9xns-sfu.js';
import {compareSemanticVersion} from '../../imports/ec9xns/ec9xns-update.js';

const ConnectedStep = (props) => {
  ConnectedStep.propTypes = {
    setState: PropTypes.func.isRequired,
    scannerInfo: PropTypes.object.isRequired,
    setUpdateCandidate: PropTypes.func.isRequired,
    updateURL: PropTypes.any.isRequired
  };


  const doGetUpdateObj = () => {
    if (props.scannerInfo.model === EC9600_PARAMS.MODEL) {
      if (compareSemanticVersion(EC9600_PARAMS.VERSIONS._1_2_0_243, props.scannerInfo.version) >= 0) {
        // version is or is below 1.2.0.243
        if (compareSemanticVersion(EC9600_PARAMS.VERSIONS._1_1_0_208, props.scannerInfo.version) > 0) {
          // version is below 1.1.0.208
          props.setState(CONNECTION_STATE.UNABLE_UPDATE);
          return;
        } else {
          // version is or is up 1.1.0.208
          props.setState(CONNECTION_STATE.REDIRECT_TO_DASHBOARD);
          return;
        }
      }
      // version is up 1.2.0.243
    }

    const doing = async () => {
      const updateObjection = {
        updateURL: props.updateURL? props.updateURL: PROD_UPDATE_SERVER_URL
      };

      await checkScannerUpdates(null, updateObjection).then((updateCandidate) => {
        if (updateCandidate) {
          props.setUpdateCandidate(updateCandidate);
          props.setState(CONNECTION_STATE.UPDATE_AVAILABLE);
        } else {
          console.log('updateCandidate is null');
          props.setState(CONNECTION_STATE.UPDATE_DONE);
        }
      }, (checkErr) => {
        console.log('checkErr: ' + checkErr);
        props.setState(CONNECTION_STATE.RECONNECTING);
      });
    };

    doing();
  };
  useEffect(doGetUpdateObj, []);


  return (
    <Fragment>
      <div>
        RDM Network Scanner: {props.scannerInfo.sn} is connected<p/>&nbsp;<p/>
        Checking for updates. Please wait
      </div>
      <Stack alignItems="center"><CircularProgress/></Stack>
    </Fragment>
  );
};

export default ConnectedStep;
